<template>
  <l-layout :layout="[ 'xs12']" bottom-space>
    <v-card>
      <!--Fixme 固定高度在vutify@1.4中已经不可用，会造成父级元素（v-card-title）塌陷-->
      <v-card-title class="py-0 my-0" style="height: 80px">
        <span :class="data.name ? '':'grey--text'" class="title px-2">{{data.name || '分组名称'}}</span>
        <slot name="time">
          <v-layout class="pl-4" wrap>
            <v-flex xs4>
              <span class="grey--text caption mr-2">上次更新</span>
              <span
                :class="data.lastUpdateTime ? '':'grey--text'"
                class="pr-4">{{$L.time.stringify(data.lastUpdateTime) || 'N/A'}}</span>
            </v-flex>
            <v-flex xs4>
              <span class="grey--text caption mr-2">创建时间</span>
              <span
                :class="data.creationTime ? '':'grey--text'"
                class="pr-4">{{$L.time.stringify(data.creationTime) || 'N/A'}}</span>
            </v-flex>
            <v-flex xs4>
              <span class="grey--text caption mr-2">过期时间</span>
              <span
                :class="''"
                class="pr-4">{{$L.time.stringify(data.expirationTime)}}</span>
            </v-flex>
          </v-layout>
        </slot>
        <v-spacer></v-spacer>
        <slot name="title-actions"></slot>
      </v-card-title>
      <v-tabs grow v-model="tab">
        <v-tab key="info">分组信息</v-tab>
        <v-tab key="vehicle">车辆管理</v-tab>
        <v-tab key="rule">分组规则</v-tab>
        <v-tab key="specific">特殊规则</v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <v-tabs-items v-model="tab">
        <v-tab-item key="info">
          <v-card-text>
            <v-container class="pb-0" fluid grid-list-md>
              <v-layout v-if="!data.editInfo" wrap>
                <v-flex :class="opt.layout" :key="i" v-for="(opt, i) in opts">
                  <info-cell v-bind="opt" v-model="data[opt.key]"></info-cell>
                </v-flex>
              </v-layout>
              <v-layout v-else wrap>
                <v-flex :class="opt.layout" :key="i" v-for="(opt, i) in formDefine">
                  <l-input :config="opt" v-model="infoForm[opt.key]"></l-input>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="goEditInfo" color="primary" flat large v-if="!data.editInfo">编辑</v-btn>
            <v-btn @click="goReadonly" color="grey" flat large v-if="data.editInfo">取消</v-btn>
            <v-btn
              :loading="data.loading"
              @click="setGroupInfo"
              color="primary"
              flat
              large
              v-if="data.editInfo">提交
            </v-btn>
          </v-card-actions>
        </v-tab-item>
        <v-tab-item key="vehicle">
          <v-card >
            <l-data-table
              :get-data-func="getVehicles"
              :headers="vehicleHeaders"
              :filter-items="filter"
              flat
              ref="vehicleTable"
              title-text="分组车辆列表"
              @click:row="goDetails($event.item)"
              clickable
            >
              <!--<template slot="title">-->
              <!--<v-btn class="mx-0" color="primary" flat>添加车辆</v-btn>-->
              <!--<v-btn class="mx-0" color="primary" flat>批量添加</v-btn>-->
              <!--</template>-->
              <!--<template slot="row-action" slot-scope="{item}">-->
              <!--<td @click.stop class="mx-0 px-0 text-xs-center">-->
              <!--<v-btn icon>-->
              <!--<v-icon small>$vuetify.icons.more</v-icon>-->
              <!--</v-btn>-->
              <!--</td>-->
              <!--</template>-->
              <template slot="row-action" slot-scope="{item}">
                <td @click.stop class="px-0 mx-0 text-xs-center">
                  <v-tooltip left>
                    <v-btn  @click="deleteVehicleConfirm(item)" slot="activator" icon>
                      <v-icon small>$vuetify.icons.delete</v-icon>
                    </v-btn>
                    <span>删除配置</span>
                  </v-tooltip>
                </td>
              </template>
            </l-data-table>
          </v-card>
          <l-fixed-btn
            @click="addVehicle"
            icon="$vuetify.icons.add"
          ></l-fixed-btn>
        </v-tab-item>
        <v-tab-item key="rule" style="min-height: 300px;">
          <v-layout class="py-2" wrap>
            <v-flex xs12>
              <v-layout column>
                <p class="pl-4 mt-3">有效规则</p>
                <l-pass-rule-list :pass-rules="data.rules">
                  <div @click.stop slot="action" slot-scope="{item, index}">
                    <l-option-menu
                      :options="options"
                      @delete="deletePassRule(item)"
                      @edit="openSetRuleDialog('edit',item, index)">
                      <v-btn icon slot="activator" small>
                        <v-icon small>$vuetify.icons.more</v-icon>
                      </v-btn>
                    </l-option-menu>
                  </div>
                </l-pass-rule-list>
              </v-layout>
            </v-flex>
            <v-flex class="px-2" xs12>
              <v-btn @click="openSetRuleDialog('new', null, data.rules.length)" color="primary" flat>添加规则</v-btn>
            </v-flex>
            <v-flex xs12>
              <v-layout column>
                <v-divider></v-divider>
                <p class="pl-4 mt-3">失效规则</p>
                <l-pass-rule-list :pass-rules="data.failureRules">
                </l-pass-rule-list>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-tab-item>
        <v-tab-item key="specific" style="min-height: 300px;">
          <v-layout class="py-2" wrap>
            <v-flex xs12>
              <l-pass-rule-list :pass-rules="specificalRules" specific>
                <div @click.stop slot="action" slot-scope="{item, index}">
                  <l-option-menu
                    :options="options"
                    @delete="deleteSpecific(item)"
                    @edit="openSetSpecificDialog('edit',item, index)">
                    <v-btn icon slot="activator" small>
                      <v-icon small>$vuetify.icons.more</v-icon>
                    </v-btn>
                  </l-option-menu>
                </div>
              </l-pass-rule-list>
            </v-flex>
            <v-flex class="px-2" xs12>
              <v-btn
                @click="openSetSpecificDialog('new', null, data.specifics.length)"
                color="primary" flat>添加规则
              </v-btn>
            </v-flex>
          </v-layout>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <v-dialog max-width="900px" persistent scrollable v-model="passRuleDialog.activate">
      <set-pass-rule-content
        :authority="authority"
        :params="{index: passRuleDialog.index, type: authority.name}"
        :rule="passRuleDialog.item"
        :status="passRuleDialog.status"
        @cancel="closeSetRuleDialog"
        @save="setPassRule($event.newItem)"
        ref="ruleContent"
        v-if="passRuleDialog.activate"
      ></set-pass-rule-content>
    </v-dialog>
    <v-dialog max-width="900px" persistent scrollable v-model="specificRuleDialog.activate">
      <set-pass-rule-content
        :authority="authority"
        :params="{index: specificRuleDialog.index, type: '特殊规则'}"
        :rule="specificRuleDialog.item"
        :status="specificRuleDialog.status"
        @cancel="closeSetSpecificDialog"
        @save="setSpecificRule($event.newItem)"
        ref="specificContent"
        v-if="specificRuleDialog.activate"
      >
        <template slot="append" slot-scope="{newItem, status}">
          <v-subheader class="mx-0">车辆信息</v-subheader>
          <v-layout wrap class="mb-4">
            <v-flex xs12>
              <l-autocomplete
                :disabled="status === 'edit'"
                label="车辆号牌"
                :get-data="findVehicleInGroup"
                item-text="objectId"
                prepend-icon="$vuetify.icons.car"
                v-model="newItem.vehicle"
              ></l-autocomplete>
            </v-flex>
            <v-flex xs12>
              <v-switch
                label="单独执行"
                v-model="newItem.isStandalone"
              ></v-switch>
            </v-flex>
          </v-layout>
        </template>
      </set-pass-rule-content>
    </v-dialog>
    <v-dialog max-width="500px" persistent scrollable v-model="addVehicleInfo.flag">
      <v-layout column justify-center>
        <v-card class="pa-2">
          <v-subheader class="mx-0">车辆信息</v-subheader>
          <v-layout wrap class="mb-4">
            <v-flex xs12>
              <l-autocomplete
                label="车辆号牌"
                :get-data="findRegisterVehicles"
                item-text="plateNumber"
                prepend-icon="$vuetify.icons.car"
                v-model="addVehicleInfo.plate"
              ></l-autocomplete>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="手机号码" v-model="addVehicleInfo.phone" prepend-icon="$vuetify.icons.phone" readonly>
              </v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="车主姓名" v-model="addVehicleInfo.name" prepend-icon="$vuetify.icons.person" readonly>
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify-center>
            <v-btn class="primary" @click="addVehicleSubmit" :loading="addVehicleInfo.loading">提交</v-btn>
            <v-btn class="error" @click="addVehicleInfo.flag = false">取消</v-btn>
          </v-layout>
        </v-card>
      </v-layout>
    </v-dialog>
  </l-layout>
</template>

<script>
import LPassRuleList from '../../../components/LPassRuleList'
import InfoCell from '../../../components/infoCell'
import {ReservationGroup, ReservationAuthority, SpecificRule} from '../../../object'
import {VEHICLE_ACTION_HEADERS} from '../../../consts/reservation'
import {RULE_ACTION_HEADERS, SPECIFIC_ACTION_HEADERS} from '../../../consts/pass'
import {passRule} from '@/mixins'
import SetPassRuleContent from '../../../components/SetPassRuleContent'

export default {
  name: 'reservationGroupContent',
  components: {SetPassRuleContent, InfoCell, LPassRuleList},
  mixins: [passRule],
  props: {
    data: {
      type: Object,
      required: true,
    }
  },
  data () {
    return {
      specificRuleDialog: {
        activate: false,
        item: {},
        index: 0,
        status: 0
      },
      specificalRules:[],
      addVehicleInfo: {
        plate: '',
        phone: '',
        name: '',
        flag: false,
        loading: false
      },
      infoForm: {},
      filter: [
        {
          prependIcon: '$vuetify.icons.edit',
          key: 'rhdata',
          value: '{"r_h_status":"1"}',
          label: '是否有效',
          type: 'select',
          layout: ['xs12', 'sm4'],
          items: [
            {
              value: '',
              text: '全部'
            },
            {
              value: '{"r_h_status":"1"}',
              text: '有效'
            },
            {
              value: '{"r_h_status":"-1"}',
              text: '失效'
            }],
        },
        {
          prependIcon: '$vuetify.icons.phone',
          key: 'objectPhone',
          value: '',
          label: '手机号码',
          type: 'input',
          layout: ['xs12', 'sm4'],
        },
      ],
      authority: new ReservationAuthority({
        // 必填，预约类型名称
        name: '通行分组',

        // 最小起始时间，为0则为当天，-1为无限
        minStartDay: 0,

        // 最大起始时间，为0则为当天，-1为无限
        maxStartDay: -1,

        // 时间片最小可选时间
        // minSliceTime: '00:00',

        // 时间片最大可选时间
        // maxSliceTime: '23:59',

        // 最大预约时段天数，为0则为仅限当天（起始日期 = 截止日期），-1为无限
        maxDurationDay: -1,

        // 最大配置规则数
        maxRuleAmount: 100,

        // 单次最大配置车辆数
        maxVehicleAmount: 1000,

        // 可使用的规则类型：sectional(时段型), day(按天循环), week(按周循环)
        type: ['sectional', 'day', 'week'],

        // 是否可以定义分组名称和描述
        editGroupInfo: true,

        // 是否可定义特殊进出场提示
        editPrompt: false,
      }),
      tab: 0,
      vehicleHeaders: [
        {text: '车牌号码', value: 'objectId', sortable: true, align: 'left'},
        {text: '手机号码', value: 'objectPhone', sortable: false, align: 'left'},
        {text: '是否有效', value: 'rhdata', align: 'left', placeholder: 'N/A', f: (v) => ((JSON.parse(v)).r_h_status === '-1' ? '失效' : '有效')},
        {text: '', value: '', sortable: false}
      ],
      ruleHeaders: RULE_ACTION_HEADERS,
      specificHeaders: SPECIFIC_ACTION_HEADERS,
      rules: [],
      specifics: [],
      options: [
        {
          event: 'edit',
          icon: '$vuetify.icons.edit',
          label: '编辑',
        },
        {
          event: 'delete',
          icon: '$vuetify.icons.delete',
          label: '删除',
        },
      ],
      opts: [
        {
          key: 'name',
          label: '分组名称',
          layout: ['xs12'],
          icon: '$vuetify.icons.group',
        },
        {
          key: 'description',
          label: '分组描述',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.description',
        },
        {
          key: 'priority',
          label: '优先级别',
          layout: ['xs12'],
          icon: '$vuetify.icons.level',
        },
        /*        {
          key: 'expirationTime',
          label: '过期时间',
          layout: ['xs12', 'sm6'],
          icon: '$vuetify.icons.datetime',
        }, */
        {
          key: 'osdMsgIn',
          label: '进场屏显提示',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.led',
        },
        {
          key: 'vcbMsgIn',
          label: '进场语音提示',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.audio',
        },
        {
          key: 'osdMsgOut',
          label: '出场屏显提示',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.led',
        },
        {
          key: 'vcbMsgOut',
          label: '出场语音提示',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.audio',
        },
      ],
      formDefine: [
        {
          type: 'input',
          key: 'name',
          label: '分组名称',
          layout: ['xs12'],
          prependIcon: '$vuetify.icons.group',
        },
        {
          type: 'input',
          key: 'description',
          label: '分组描述',
          layout: ['xs12'],
          prependIcon: '$vuetify.icons.description',
        },
        {
          type: 'input',
          key: 'priority',
          label: '优先级别',
          layout: ['xs12'],
          prependIcon: '$vuetify.icons.level',
        },
        /*        {
          type: 'datetime',
          key: 'expirationTime',
          label: '过期时间',
          layout: ['xs12', 'sm6'],
        }, */
        {
          rows: 1,
          autoGrow: true,
          type: 'textarea',
          key: 'ledPromptIn',
          label: '进场屏显提示',
          layout: ['xs12'],
          prependIcon: '$vuetify.icons.led',
        },
        {
          rows: 1,
          autoGrow: true,
          type: 'textarea',
          key: 'audioPromptIn',
          label: '进场语音提示',
          layout: ['xs12'],
          prependIcon: '$vuetify.icons.audio',
        },
        {
          rows: 1,
          autoGrow: true,
          type: 'textarea',
          key: 'ledPromptOut',
          label: '出场屏显提示',
          layout: ['xs12'],
          prependIcon: '$vuetify.icons.led',
        },
        {
          rows: 1,
          autoGrow: true,
          type: 'textarea',
          key: 'audioPromptOut',
          label: '出场语音提示',
          layout: ['xs12'],
          prependIcon: '$vuetify.icons.audio',
        },
      ],
    }
  },
  methods: {
    goEditInfo () {
      this.infoForm = new ReservationGroup(this.data)
      this.infoForm.ledPromptIn = this.data.osdMsgIn
      this.infoForm.ledPromptOut = this.data.osdMsgOut
      this.infoForm.audioPromptIn = this.data.vcbMsgIn
      this.infoForm.audioPromptOut = this.data.vcbMsgOut
      this.data.editInfo = true
    },
    goReadonly () {
      this.data.editInfo = false
    },
    async setGroupInfo () {
      try {
        this.$set(this.data, 'loading', true)
        let g = await this.$store.dispatch('reservation/setReservationGroup', this.infoForm)
        this.$emit('refresh')
        /*      let keys = [
                  'name',
                  'description',
                  'priority',
                  'expirationTime',
                  'ledPromptIn',
                  'audioPromptIn',
                  'ledPromptOut',
                  'audioPromptOut',
                ]
                for (let key of keys) {
                  this.$set(this.data.obgrp, key, g[key])
                } */
        /* this.goReadonly() */
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      finally {
        this.$set(this.data, 'loading', false)
      }
    },
    openSetSpecificDialog (status, item, index) {
      this.specificRuleDialog = {
        activate: true,
        status: status,
        item: item || new SpecificRule(),
        index: index,
      }
    },
    closeSetSpecificDialog () {
      this.specificRuleDialog = {
        activate: false,
        status: 'new',
        item: {},
        index: 0,
      }
    },
    async setSpecificRule (rule) {
      try {
        console.log(rule)
        await this.$store.dispatch('passControl/setSpecificRule', rule)
        this.closeSetSpecificDialog()
        this.getSpecifics()
        this.$L.alert('success', `操作成功`)
      }
      catch (e) {
        console.error(e)
        this.$L.alert('error', e.message)
        this.$refs.specificContent.stopLoading()
      }
    },
    async setPassRule (rule) {
      if (!rule.groupId) {
        rule.groupId = this.data.id
      }
      try {
        await this.$store.dispatch('reservation/setRule', rule)
        this.closeSetRuleDialog()
        this.getRules()
        this.$L.alert('success', `操作成功`)
      }
      catch (e) {
        this.$L.alert('error', e.message)
        this.$refs.ruleContent.stopLoading()
      }
    },
    async findVehicleInGroup (searchValue) {
      try {
        let {items} = await this.getVehicles({
          pagination: {},
          search: {key: 'objectId', value: searchValue},
          filterItems: [{key: 'rhdata', value: '{"r_h_status":"1"}'}]
        })
        return items
      }
      catch (e) {
        this.$L.alert('error', e.message)
        return []
      }
    },
    async findRegisterVehicles (searchValue) {
      try {
        let {items} = await this.$store.dispatch('passControl/getRegisterVehicles', {
          pagination: {},
          search: {key: 'plate', value: searchValue},
          filter: [{key: 'status', value: ['1']}]
        })
        return items
      }
      catch (e) {
        this.$L.alert('error', e.message)
        return []
      }
    },
    async deletePassRule (rule) {
      let {res, close} = await this.$L.confirm({
        title: '确认删除',
        text: '确认删除该规则？'
      })
      if (res) {
        try {
          await this.$store.dispatch('reservation/deleteRules', [rule])
          this.getRules()
          this.$L.alert('success', '删除成功')
          this.$emit('refresh')
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async deleteSpecific (rule) {
      let {res, close} = await this.$L.confirm({
        title: '确认删除',
        text: '确认删除该规则？'
      })
      if (res) {
        try {
          await this.$store.dispatch('reservation/deleteRules', [rule])
          this.getSpecifics()
          this.$L.alert('success', '删除成功')

        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    getVehicles ({pagination, sortStack, filterItems = [], search}) {
      let filter = {}
      filterItems.forEach(f => {
        filter[f.key] = f
      })
      return this.$store.dispatch('passControl/getVehicles', {
        group: this.data,
        pagination,
        sortStack,
        filter,
        search: {key: 'objectId', value: search}
      })
    },
    async getRules () {
      try {
        // Fixme 需要从页面上支持分页
        let {items} = await this.$store.dispatch('reservation/getRules', {
          groupId: this.data.id,
          pagination: {page: 1, rowsPerPage: 100},
        })
        this.data.rules = []
        this.data.failureRules = []
        for (let i = 0; i < items.length; i++) {
          let rule = items[i]
          if (rule.status === '-1') {
            this.data.failureRules.push(rule)
          }
          else {
            this.data.rules.push(rule)
          }
        }
      }
      catch (e) {
        console.error(e)
        this.$L.alert('error', e.message)
      }
    },
    async getSpecifics () {
      try {
        // Fixme 需要从页面上支持分页
        let {items} = await this.$store.dispatch('reservation/getAllSpecifics', {
          group: this.data,
          pagination: {page: 1, rowsPerPage: 100},
        })
        this.data.specifics = items
        this.specificalRules = items
        console.log(this.data.specifics)
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
    },
    addVehicle () {
      // console.log(this.data)
      this.addVehicleInfo.flag = true
    },
    async addVehicleSubmit () {
      let params = {
        'id': '',
        'objectId': this.addVehicleInfo.plate.plateNumber,
        'objectPhone': this.addVehicleInfo.phone,
        'obgrpId': this.data.id
      }
      this.addVehicleInfo.loading = true
      let res = await this.$store.dispatch('passControl/addVehicle', params)
      this.addVehicleInfo.loading = false
      if (res.data.status + '' === '1') {
        this.$L.alert('success', {message: '添加成功'})
        this.addVehicleInfo.flag = false
        this.addVehicleInfo.plate = ''
        this.addVehicleInfo.phone = ''
        this.$refs.vehicleTable.refresh()
      }
      else {
        this.$L.alert('error', {message: '添加失败，原因：' + res.data.msg})
      }
    },
    async deleteVehicleConfirm (item) {
      let {res, close} = await this.$L.confirm({
        title: '确认删除该车辆？',
        text: '车牌号码:' + item.objectId
      })
      if (res) {
        try {
          await this.deleteVehicle(item)
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async deleteVehicle (item) {
      let ids = []
      ids.push(item.id)
      let res = await this.$store.dispatch('passControl/deleteVehicle', ids)
      if (res.data.status + '' === '1') {
        this.$L.alert('success', {message: '删除成功'})
        this.$refs.vehicleTable.refresh()
      }
      else {
        this.$L.alert('error', {message: '删除失败,原因:' + res.data.msg})
      }
    },
    goDetails (item) {
      console.log(item)
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({
          name: 'VehicleStatisticDetails',
          params: {
            plate: item.objectId,
          },
        })
      }
    },
    async getAddVehiclePhone () {
      try {
        let {items} = await this.$store.dispatch('passControl/getRegisterVehicles', {
          pagination: {},
          search: {key: 'plate', value: this.addVehicleInfo.plate.plateNumber},
          filter: [{key: 'status', value: ['1']}]
        })
        if(items.length!==0){
          this.addVehicleInfo.phone = items[0].phone
          this.addVehicleInfo.name = items[0].name
        }else{
          this.addVehicleInfo.phone = ''
          this.addVehicleInfo.name = ''
        }
      }
      catch (e) {
        this.$L.alert('error', e.message)
        return []
      }
    }
  },
  watch: {
    'addVehicleInfo.plate' (val, oldVal) {
      console.log(val)
      if (val === null) {
        this.addVehicleInfo.phone = ''
      }
      else {
        this.getAddVehiclePhone()
      }
    }
  },
  activated () {
    if (this.$L.tab.currentTab && !this.$L.tab.currentTab.desc) {
      this.$L.tab.set(this.$L.tab.current, {desc: this.data.name})
    }
    console.log('activated', this.data)
  },
  created () {
    // console.log(this.data)
    if (this.$L.tab.currentTab && !this.$L.tab.currentTab.desc) {
      this.$L.tab.set(this.$L.tab.current, {desc: this.data.name})
    }
    this.getRules()
    this.getSpecifics()
  }
}
</script>

<style scoped>

</style>
